import { createContext } from "react";
import { LockForecastContextType } from "./type";

const defaultValue: LockForecastContextType = {
  lockLoading: false,
  unlockLoading: false,
  isLockUnlockLoading: false,
  copyForecastToDefaultSettings: async () => ({}) as any,
  unlockForecastFromDefaultSettings: async () => ({}) as any,
  lockForecast: async () => {},
  unlockForecast: async () => {},
};

export const LockForecastContext =
  createContext<LockForecastContextType>(defaultValue);

